import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { LineChart } from '@mui/x-charts/LineChart';
import ChartDemoWrapper from '../ChartDemoWrapper';

/* Source: https://data.worldbank.org/indicator/FP.CPI.TOTL.ZG?end=2024&locations=DE&start=1960&view=chart */
const years = [
  1960, 1961, 1962, 1963, 1964, 1965, 1966, 1967, 1968, 1969, 1970, 1971, 1972, 1973, 1974, 1975,
  1976, 1977, 1978, 1979, 1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991,
  1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007,
  2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023,
  2024,
];

const germanyInflationData = [
  1.53661234295201, 2.29369500700884, 2.84327019799062, 2.9669597758771, 2.33573581177832,
  3.24231923668133, 3.53306035477689, 1.79604992213175, 1.470289313277, 1.91267848797596,
  3.45024936360895, 5.24097448273094, 5.4849331221432, 7.03202399303898, 6.98643109327497,
  5.91033626324104, 4.24663102299209, 3.73416240635147, 2.71869696123339, 4.04362006473399,
  5.44105754460347, 6.34424277746325, 5.24104507228422, 3.29341474302854, 2.4057933993196,
  2.0662330121658, -0.129413360854742, 0.24990610870503, 1.27411894006923, 2.78056955569751,
  2.69646824292392, 4.04703259753466, 5.05697796731731, 4.47457650752808, 2.69305639854954,
  1.70616041317076, 1.44972701963239, 1.93937198922729, 0.911183535014403, 0.585433064230783,
  1.44026838719741, 1.98385731334471, 1.42080615551526, 1.03422218628562, 1.66573696655992,
  1.54691114751328, 1.57742642840563, 2.29834400700951, 2.62837981637219, 0.312739007368447,
  1.1038103778926, 2.07517283735874, 2.00848884782956, 1.50472330251876, 0.906794000434246,
  0.514426137125456, 0.491747008445174, 1.50949485109628, 1.73216879766942, 1.44565976888253,
  0.144877925813982, 3.06666666666673, 6.87257438551097, 5.94643667725823, 2.2564981433876,
];

const ukInflationRate = [
  1.00357570390172, 3.4474962304662, 4.19649888238551, 2.01854355976229, 3.28158694697213,
  4.77377455386914, 3.90961779211889, 2.48211560474804, 4.69742798827245, 5.44666363048887,
  6.36656841727441, 9.44483742337133, 7.07109839479797, 9.19603316657812, 16.0440111889861,
  24.2072876743291, 16.5595225588084, 15.8402667458768, 8.26314103860768, 13.4212799774012,
  17.9659242656857, 11.8766265142296, 8.59886383332186, 4.60930327269779, 4.96071097821927,
  6.07139434015119, 3.42760940369314, 4.14892232052945, 4.15535171583102, 5.76024909185262,
  8.06346090938833, 7.46178295746934, 4.59154929577461, 2.55857796929705, 2.21901260504205,
  2.69749518304432, 2.85178236397749, 2.20114313510882, 1.82056163731557, 1.7529508005142,
  1.18295624210408, 1.53234960272418, 1.52040245947455, 1.37650038542013, 1.39039756680422,
  2.0891364902507, 2.4556616643929, 2.38656150773327, 3.52140856342539, 1.96173173560109,
  2.49265472467065, 3.8561124468282, 2.5732347965453, 2.29166666666659, 1.45112016293279,
  0.36804684232536, 1.0084173681141, 2.55775577557747, 2.29283990345938, 1.73810460086513,
  0.989486703772491, 2.51837109614213, 7.92204883147902, 6.79396706793963, 3.2715729463592,
];

const franceInflationRate = [
  4.13993575518437, 2.40046104546321, 5.33128007065639, 4.99915289796841, 3.21119170293105,
  2.70310455873084, 2.60200076636444, 2.7917770943515, 4.54320486402014, 6.04596284173893,
  5.29964124562675, 5.39751865595105, 6.06300309718187, 7.38060106398912, 13.6493174728139,
  11.6859272493228, 9.62549578155529, 9.49455467190434, 9.2505584672443, 10.6467341716664,
  13.5625788483016, 13.3144055680071, 11.9784719523806, 9.45954847235318, 7.67380262247321,
  5.83109973854516, 2.53852591781417, 3.28889821400133, 2.70081527508113, 3.49830220700749,
  3.19428338029475, 3.21340732409687, 2.36376046269353, 2.10446277124644, 1.65551532926993,
  1.79648142095595, 1.98288365089738, 1.20394294026962, 0.651126867833049, 0.537141639134645,
  1.67595988720927, 1.63478079549601, 1.9234122872706, 2.09847219146923, 2.14208964640241,
  1.74586936380482, 1.67512449608723, 1.4879980595386, 2.81286194914787, 0.0876204781574552,
  1.53112270420926, 2.11159795174994, 1.9541953161351, 0.863715497861805, 0.50775882293799,
  0.0375143805125182, 0.18333486112386, 1.03228275064662, 1.85081508315502, 1.10825492288294,
  0.476498852725066, 1.64233141038385, 5.22236748369735, 4.87835726508441, 1.99904942291463,
];

export const inflationData = years.map((year, index) => ({
  year,
  rateDE: germanyInflationData[index],
  rateUK: ukInflationRate[index],
  rateFR: franceInflationRate[index],
}));

function valueFormatter(value: number | null) {
  if (value === null) {
    return '';
  }

  return `${(value / 100).toLocaleString(undefined, { style: 'percent', maximumFractionDigits: 2 })}`;
}

const chartSetting = {
  yAxis: [{ width: 40, valueFormatter, min: -5 }],
  xAxis: [
    {
      dataKey: 'year',
      valueFormatter: (v: number | null) => (v ? v.toString() : ''),
      domainLimit: 'strict' as const,
      height: 28,
    },
  ],
};

function Line() {
  return (
    <Stack sx={{ height: '100%' }}>
      <Typography align="center">Inflation rates</Typography>
      <LineChart
        dataset={inflationData}
        series={[
          { dataKey: 'rateDE', label: 'Germany', valueFormatter },
          { dataKey: 'rateUK', label: 'United Kingdom', valueFormatter },
          { dataKey: 'rateFR', label: 'France', valueFormatter },
        ]}
        grid={{ horizontal: true }}
        {...chartSetting}
      />
    </Stack>
  );
}

export default function LineChartDemo() {
  return (
    <ChartDemoWrapper link="/x/react-charts/lines/">
      <Line />
    </ChartDemoWrapper>
  );
}
